import React from "react";
import SendTicketComponent from "./components/SendTicketComponent";

export default function SendTicket () {
    return (
        <>
            <SendTicketComponent></SendTicketComponent>
        </>
    );
};